import {environmentBase} from './environment.base';

export const environment = {
  ...environmentBase,
  production: true,
  apiUrl: 'https://selectivebits.com/api',
  googleAnalyticsID: 'G-Y6PWYVHP1B',
  recaptchaSiteKey: '6Leqd_AtAAAAAHp6N5o2THPWLRMnZAYQuEizsWvH',
};
